jQuery(document).ready(function ($) {
  $('.ctn-main-menu').click(function () {
    menuToggleClass();
  });

  $.fn.scrollToTarget = function (target) {
    var t = target.attr('href');
    console.log(t);
    var $page = $('html, body');

    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
      console.log('stopped');
    });

    $page.animate({
      scrollTop: $('' + t + '').offset().top,
    }, 1200, function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });

    return false;
  };

  // Scroll to nicht auf die Haupnavi, sondern die untergeordnete Seitennavi anwenden
  // $('.menu-modal .menu-item').click(function (event) {
  //   $target = $(this).find('a');
  //   event.preventDefault();
  //   $(this).scrollToTarget($target);
  //   menuToggleClass();
  // });

  $('.scroll-to').click(function(event){
    console.log(event);
    $target = $(this);
    event.preventDefault();
    $(this).scrollToTarget($target);
  });

  var menuToggleClass = function () {
    $menuButton = $('.ctn-main-menu');
    $menuModal = $('.menu-modal');
    $menuModalBg = $('.menu-modal-bg');
    $menuModalContent = $('.menu-modal-content');

    // Actions
    $menuButton.toggleClass('is-open');
    $menuModal.toggleClass('is-open');

    if ($menuButton.hasClass('is-open')) {
      $menuModalBg.css({
        opacity: 1,
        visibility: 'visible',
      });
      $menuModalContent.css({
        opacity: 1,
        visibility: 'visible',
      });
      $menuModal.css('z-index', 98);
    } else {
      $menuModalBg.css({
        opacity: 0,
      });
      $menuModalContent.css({
        opacity: 0,
      });
      $menuModal
        .delay(400)
        .queue(function (next) {
          $menuModal.css('z-index', -1);
          $menuModalBg.css({
            visibility: 'hidden',
          });
          $menuModalContent.css({
            visibility: 'hidden',
          });
          next();
        });
    }
  };
});
